export const llmOptions = {
  OPENAI: [
    { label: "GPT 4o", value: "gpt-4o" },
    { label: "GPT 4o Mini", value: "gpt-4o-mini" },
    { label: "GPT 4.1 Mini", value: "gpt-4.1-mini" },
    { label: "GPT 4.1", value: "gpt-4.1" },
    { label: "GPT 4.1 Nano", value: "gpt-4.1-nano" },
    { label: "o3 Mini", value: "o3-mini" },
    { label: "GPT 5", value: "gpt-5" },
    { label: "GPT 5 Mini", value: "gpt-5-mini" },
    { label: "GPT 5 Nano", value: "gpt-5-nano" },
    { label: "GPT 5.1", value: "gpt-5.1" },
    { label: "GPT 5.2", value: "gpt-5.2" },
    { label: "GPT 5.1 Mini", value: "gpt-5.1-mini" },
    { label: "GPT 5.1 Nano", value: "gpt-5.1-nano" },
  ],
  GROQ: [
    { label: "LLaMA 3.1 8b Instant", value: "llama-3.1-8b-instant" },
    { label: "LLaMA 3 8b", value: "llama3-8b-8192" },
    { label: "OpenAI GPT OSS 20b", value: "openai/gpt-oss-20b" },
    { label: "OpenAI GPT OSS 120b", value: "openai/gpt-oss-120b" },
  ],
  DEEPSEEK: [
    { label: "Deepseek Chat", value: "deepseek-chat" },
    { label: "Deepseek Reasoner", value: "deepseek-reasoner" },
  ],
  GOOGLE: [
    { label: "Gemini 1.5 Flash v1", value: "gemini-1.5-flash-001" },
    { label: "Gemini 2.0 Flash Experimental", value: "gemini-2.0-flash-exp" },
    { label: "Gemini 2.0 Flash v1", value: "gemini-2.0-flash-001" },
    { label: "Gemini 2.0 Flash Lite v1", value: "gemini-2.0-flash-lite-001" },
    { label: "Gemini 2.0 Flash Lite (Preview 05/02/25)", value: "gemini-2.0-flash-lite-preview-02-05" },
    { label: "Gemini 2.5 Pro Exp (Preview 25/03/25)", value: "gemini-2.5-pro-preview-03-25" },
    { label: "Gemini 2.0 Flash Thinking (Preview 21/01/25)", value: "gemini-2.0-flash-thinking-exp-01-21" },
    { label: "Gemini 2.5 Flash Lite", value: "gemini-2.5-flash-lite" },
    { label: "Gemini 2.5 Flash (Preview 20/05/25)", value: "gemini-2.5-flash-preview-05-20" },
    { label: "Gemini 2.5 Flash", value: "gemini-2.5-flash" },
    { label: "Gemini 2.5 Pro", value: "gemini-2.5-pro" },
    { label: "Gemini 3 Pro Preview", value: "gemini-3-pro-preview" },
    { label: "Gemini 2.5 Flash Lite (Preview 17/06/2025)", value: "gemini-2.5-flash-lite-preview-06-17" },
    { label: "Gemini 1.5 Pro v1", value: "gemini-1.5-pro-001" },
  ],
  OPENROUTER: [
    { label: "Qwen 3.5 27B", value: "qwen/qwen3.5-27b" },
    { label: "Gemma 4 31B IT", value: "google/gemma-4-31b-it" },
  ],
  FIREWORKS: [
    { label: "Qwen 3 235B A22B", value: "accounts/fireworks/models/qwen3-235b-a22b" },
    { label: "Qwen 3 30B A3B", value: "accounts/fireworks/models/qwen3-30b-a3b" },
    { label: "LLaMA 4 Maverick Instruct", value: "accounts/fireworks/models/llama4-maverick-instruct-basic" },
    { label: "LLaMA 4 Scout Instruct", value: "accounts/fireworks/models/llama4-scout-instruct-basic" },
    { label: "Kimi K2 Instruct", value: "accounts/fireworks/models/kimi-k2-instruct" },
    { label: "Qwen 3 235B A22B Instruct (25/07)", value: "accounts/fireworks/models/qwen3-235b-a22b-instruct-2507" },
    { label: "OpenAI GPT OSS 20b", value: "accounts/fireworks/models/gpt-oss-20b" },
    { label: "OpenAI GPT OSS 120b", value: "accounts/fireworks/models/gpt-oss-120b" },
    { label: "Deepseek V3p1 Terminus", value: "deepseek-ai/deepseek-v3p1-terminus" },
    { label: "GLM 4.6", value: "fireworks/glm-4p6" },
    { label: "GLM 4.7", value: "accounts/fireworks/models/glm-4p7" },
    { label: "Minimax M2", value: "fireworks/minimax-m2" },
    { label: "Minimax M2.1", value: "accounts/fireworks/models/minimax-m2p1" },
    { label: "Qwen Vision 235B A22B Instruct", value: "accounts/fireworks/models/qwen3-vl-235b-a22b-instruct" },
    { label: "Qwen Vision 30B A3B Instruct", value: "accounts/fireworks/models/qwen3-vl-30b-a3b-instruct" },
  ],
  VERBOO: [
    { label: "Qwen 3.6 27B", value: "qwen3.6-27b" },
  ],
  MIMO: [
    { label: "Mimo v2.5", value: "mimo-v2.5" },
    { label: "Mimo v2.5 Pro", value: "mimo-v2.5-pro" },
    { label: "Mimo v2.5 Pro UltraSpeed", value: "mimo-v2.5-pro-ultraspeed" },
  ],
};

export const rerankerOptions = {
  OPENAI: [
    { label: "GPT 4.1 Nano", value: "gpt-4.1-nano" },
    { label: "GPT 5 Nano", value: "gpt-5-nano" },
  ],
  DEEPSEEK: [{ label: "Deepseek Chat", value: "deepseek-chat" }],
  GOOGLE: [
    { label: "Gemini 2.0 Flash V1", value: "gemini-2.0-flash-001" },
    { label: "Gemini 2.5 Flash", value: "gemini-2.5-flash" },
    { label: "Gemini 2.5 Flash Lite", value: "gemini-2.5-flash-lite" },
    { label: "Gemini 2.0 Flash Lite V1", value: "gemini-2.0-flash-lite-001" },
  ],
  FIREWORKS: [
    { label: "LLaMA 4 Scout Instruct", value: "accounts/fireworks/models/llama4-scout-instruct-basic" },
    { label: "Qwen 3 30B A3B", value: "accounts/fireworks/models/qwen3-30b-a3b" },
  ],
  GROQ: [
    { label: "LLaMA 3.1 8b Instant", value: "llama-3.1-8b-instant" },
    { label: "LLaMA 3 8b", value: "llama3-8b-8192" },
  ],
  OPENROUTER: [
    { label: "Ling 2.6 Flash", value: "inclusionai/ling-2.6-flash" },
  ],
};

export const audioInterpreterOptions = {
  OPENAI: [
    { label: "Whisper V2", value: "whisper-1" },
    { label: "GPT 4o Mini Transcribe", value: "gpt-4o-mini-transcribe" },
    { label: "GPT 4o Transcribe", value: "gpt-4o-transcribe" },
  ],
};

export const audioProviderOptions = [{ label: "OpenAI", value: "OPENAI" }];

export const realtimeProviderOptions = [{ label: "OpenAI", value: "OPENAI" }];

export const realtimeModelOptions = {
  OPENAI: [{ label: "GPT Realtime 2.1", value: "gpt-realtime-2.1" }],
};

export const realtimeVoiceOptions = {
  OPENAI: [
    { label: "Marin", value: "marin" },
    { label: "Cedar", value: "cedar" },
  ],
};
